import script from "./LoginCRM360.vue?vue&type=script&lang=ts&setup=true"
export * from "./LoginCRM360.vue?vue&type=script&lang=ts&setup=true"

import "./LoginCRM360.vue?vue&type=style&index=0&id=224f4c98&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-224f4c98"]])

export default __exports__